var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckoutPickupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pickup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M55.5 26.532C55.5 40.909 43.1878 52.5639 28 52.5639C12.8122 52.5639 0.5 40.909 0.5 26.532C0.5 12.155 12.8122 0.500122 28 0.500122C43.1878 0.500122 55.5 12.155 55.5 26.532Z",
    fill: "#F5585C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M42.0356 34.2887L38.6801 26.5709C37.4933 26.5709 18.5063 26.5709 17.3196 26.5709L13.9636 34.2887C12.7083 37.1757 12.0625 40.2679 12.0625 43.3902V51.3257C12.0625 53.5658 13.9809 55.3818 16.3473 55.3818H39.6518C42.0183 55.3818 43.9367 53.5658 43.9367 51.3257V43.3902C43.9371 40.2679 43.2909 37.1757 42.0356 34.2887Z",
    fill: "#E2E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.0625 43.3902V51.3257C12.0625 53.5658 13.9804 55.3818 16.3469 55.3818H23.0893C21.343 55.3818 19.9275 53.5658 19.9275 51.3257V43.3902C19.9275 40.2679 20.4044 37.1757 21.3306 34.2887L23.8068 26.5709C20.4517 26.5709 17.7447 26.5709 17.3196 26.5709L13.9636 34.2887C12.7083 37.1757 12.0625 40.2679 12.0625 43.3902Z",
    fill: "#C7D6E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M37.7217 21.6471H18.2778C17.7483 21.6471 17.3197 22.0532 17.3197 22.554V26.5712H38.6802V22.554C38.6802 22.0532 38.2511 21.6471 37.7217 21.6471Z",
    fill: "#494970"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M24.765 21.6471H18.2778C17.7483 21.6471 17.3197 22.0532 17.3197 22.554V26.5712H23.8069V22.554C23.8069 22.0532 24.2355 21.6471 24.765 21.6471Z",
    fill: "#3A3A60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M33.6116 8.36877H22.2132L22.2358 10.3665C22.2384 10.6286 22.1579 10.8857 22.004 11.1042C20.9512 12.5969 20.3988 14.3555 20.4191 16.1506L20.4921 23.3508C20.5018 24.2045 21.2109 24.9268 22.1128 24.9461C23.0558 24.9666 23.822 24.2443 23.8118 23.3587C23.8215 24.2267 24.5726 24.9226 25.4891 24.9134C26.406 24.9042 27.1412 24.1932 27.1315 23.3257C27.1412 24.1932 27.8923 24.8891 28.8088 24.8799C29.7253 24.8707 30.4604 24.1602 30.4507 23.2926H30.5422C30.552 24.1463 31.2615 24.8607 32.1629 24.8799C33.106 24.9004 33.8721 24.1777 33.8624 23.2926L33.7314 19.136C33.7248 18.5205 34.5471 18.2483 34.947 18.7336L37.8531 22.26C38.5064 22.8651 39.5666 22.9011 40.2177 22.2939C40.8812 21.6755 40.8773 20.6651 40.2151 20.0509C38.4197 17.8196 36.8516 16.1066 34.7727 13.0856C34.0366 12.0162 33.6381 10.7701 33.624 9.49386L33.6116 8.36877Z",
    fill: "#F9D6BF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M34.4997 1.23371C32.4155 0.755538 30.2397 0.500122 28.0002 0.500122C25.8013 0.500122 23.664 0.745907 21.6143 1.20733V4.20574H34.4997V1.23371Z",
    fill: "#E2E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M27.687 0.50415C25.5988 0.526761 23.5663 0.767522 21.6143 1.20717V4.20558H27.687V0.50415Z",
    fill: "#C7D6E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M21.1057 12.7167C24.7877 9.53112 30.346 9.33182 34.269 12.2188C33.8563 11.3668 33.6347 10.4389 33.6241 9.49386L33.6117 8.36877H22.2133L22.2359 10.3665C22.2385 10.6286 22.158 10.8857 22.0041 11.1042C21.6449 11.6134 21.3455 12.1544 21.1057 12.7167Z",
    fill: "#EFC1A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M21.3858 8.59548H34.6149C34.7817 8.59548 34.9166 8.46777 34.9166 8.31034V4.26598C34.9166 4.10854 34.7817 3.98083 34.6149 3.98083H21.4486C21.2473 3.98083 21.0841 4.13534 21.0841 4.32586V8.31034C21.0841 8.46777 21.219 8.59548 21.3858 8.59548Z",
    fill: "#F6A221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M25.9838 6.3181C25.9838 5.0272 27.0892 3.98083 28.4529 3.98083H21.4486C21.2473 3.98083 21.0841 4.13534 21.0841 4.32586V8.31034C21.0841 8.46777 21.219 8.59548 21.3858 8.59548H28.3896C27.0608 8.59548 25.9838 7.57591 25.9838 6.3181Z",
    fill: "#F28A00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M25.9558 32.52C25.1981 32.52 24.5841 33.1016 24.5841 33.8185V35.0206H27.327V33.8185C27.327 33.1012 26.713 32.52 25.9558 32.52Z",
    fill: "#75BDEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M18.6601 43.589C19.8611 43.589 19.8611 42.9706 21.0615 42.9706C22.2625 42.9706 22.2625 43.589 23.4634 43.589C24.6639 43.589 24.6639 42.9706 25.8648 42.9706C27.0657 42.9706 27.0657 43.589 28.2666 43.589C29.2942 43.589 29.4441 43.1368 30.2177 43.0062L30.5698 39.754C30.1116 39.754 16.8152 39.754 16.3569 39.754L16.7095 43.0062C17.4831 43.1368 17.6331 43.589 18.6601 43.589Z",
    fill: "#A0D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M18.6597 43.589C19.6594 43.589 19.8274 43.1607 20.5484 43.0171L20.195 39.754C18.1156 39.754 16.5109 39.754 16.3569 39.754L16.7095 43.0062C17.4827 43.1368 17.6326 43.589 18.6597 43.589Z",
    fill: "#75BDEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M27.8265 34.791H19.0998C17.5848 34.791 16.3569 35.9534 16.3569 37.3875H30.5698C30.5698 35.9534 29.3415 34.791 27.8265 34.791Z",
    fill: "#A0D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M22.9631 34.791H19.0998C17.5848 34.791 16.3569 35.9534 16.3569 37.3875H20.2198C20.2198 35.9534 21.4481 34.791 22.9631 34.791Z",
    fill: "#75BDEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M17.9012 54.0019C17.9862 54.7858 18.6833 55.3816 19.5157 55.3816H27.4118C28.2442 55.3816 28.9418 54.7858 29.0267 54.0019L30.2435 42.7695C29.4465 42.8943 29.3062 43.3574 28.2668 43.3574C27.0659 43.3574 27.0659 42.7385 25.8649 42.7385C24.664 42.7385 24.664 43.3574 23.4635 43.3574C22.2626 43.3574 22.2626 42.7385 21.0617 42.7385C19.8612 42.7385 19.8612 43.3574 18.6603 43.3574C17.6213 43.3574 17.481 42.8943 16.684 42.7695L17.9012 54.0019Z",
    fill: "#FC757E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M19.5153 55.3819H23.3534C22.5209 55.3819 21.8234 54.7861 21.7384 54.0022L20.5238 42.7903C19.8236 42.9386 19.6484 43.3573 18.6598 43.3573C17.6208 43.3573 17.4806 42.8946 16.684 42.7694L17.9008 54.0022C17.9857 54.7861 18.6833 55.3819 19.5153 55.3819Z",
    fill: "#F5585C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M31.0488 39.8697H15.8774C15.1201 39.8697 14.5057 39.2881 14.5057 38.5713C14.5057 37.854 15.1201 37.2728 15.8774 37.2728H31.0488C31.8065 37.2728 32.4205 37.854 32.4205 38.5713C32.4205 39.2881 31.8065 39.8697 31.0488 39.8697Z",
    fill: "#75BDEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M19.021 38.5713C19.021 37.854 19.6354 37.2728 20.3927 37.2728H15.877C15.1197 37.2728 14.5057 37.854 14.5057 38.5713C14.5057 39.2881 15.1197 39.8697 15.877 39.8697H20.3927C19.635 39.8697 19.021 39.2881 19.021 38.5713Z",
    fill: "#4DADE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M34.8636 32.52C34.1059 32.52 33.4919 33.1016 33.4919 33.8185V35.0206H36.2353V33.8185C36.2353 33.1012 35.6209 32.52 34.8636 32.52Z",
    fill: "#75BDEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M27.5692 43.589C28.7701 43.589 28.7701 42.9706 29.9706 42.9706C31.1715 42.9706 31.1715 43.589 32.372 43.589C33.5729 43.589 33.5729 42.9706 34.7734 42.9706C35.9743 42.9706 35.9743 43.589 37.1752 43.589C38.2028 43.589 38.3527 43.1368 39.1264 43.0062L39.4789 39.754C39.0206 39.754 25.7242 39.754 25.266 39.754L25.6185 43.0062C26.3917 43.1368 26.5417 43.589 27.5692 43.589Z",
    fill: "#A0D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M27.5694 43.589C28.569 43.589 28.7371 43.1607 29.4577 43.0171L29.1042 39.754C27.0249 39.754 25.4201 39.754 25.2666 39.754L25.6187 43.0062C26.3919 43.1368 26.5418 43.589 27.5694 43.589Z",
    fill: "#75BDEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M36.736 34.791H28.0093C26.4943 34.791 25.266 35.9534 25.266 37.3875H39.4789C39.4789 35.9534 38.251 34.791 36.736 34.791Z",
    fill: "#A0D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M31.8722 34.791H28.0093C26.4943 34.791 25.266 35.9534 25.266 37.3875H29.1293C29.1293 35.9534 30.3572 34.791 31.8722 34.791Z",
    fill: "#75BDEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M26.8093 54.0019C26.8942 54.7858 27.5917 55.3816 28.4242 55.3816H36.3202C37.1522 55.3816 37.8498 54.7858 37.9347 54.0019L39.152 42.7695C38.3549 42.8943 38.2142 43.3574 37.1752 43.3574C35.9743 43.3574 35.9743 42.7385 34.7734 42.7385C33.5725 42.7385 33.5725 43.3574 32.3715 43.3574C31.1711 43.3574 31.1711 42.7385 29.9701 42.7385C28.7692 42.7385 28.7692 43.3574 27.5687 43.3574C26.5297 43.3574 26.3895 42.8943 25.5924 42.7695L26.8093 54.0019Z",
    fill: "#F6A221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M28.4242 55.3819H32.2618C31.4294 55.3819 30.7323 54.7861 30.6473 54.0022L29.4327 42.7903C28.7321 42.9386 28.5569 43.3573 27.5687 43.3573C26.5297 43.3573 26.389 42.8946 25.5924 42.7694L26.8093 54.0022C26.8942 54.7861 27.5917 55.3819 28.4242 55.3819Z",
    fill: "#F28A00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M39.959 39.8697H24.7876C24.0298 39.8697 23.4159 39.2881 23.4159 38.5713C23.4159 37.854 24.0298 37.2728 24.7876 37.2728H39.959C40.7162 37.2728 41.3302 37.854 41.3302 38.5713C41.3302 39.2881 40.7162 39.8697 39.959 39.8697Z",
    fill: "#75BDEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M27.9316 38.5713C27.9316 37.854 28.5456 37.2728 29.3028 37.2728H24.7876C24.0298 37.2728 23.4159 37.854 23.4159 38.5713C23.4159 39.2881 24.0298 39.8697 24.7876 39.8697H29.3028C28.5456 39.8697 27.9316 39.2881 27.9316 38.5713Z",
    fill: "#4DADE2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutPickupIcon);
export default __webpack_public_path__ + "static/media/checkout-pickup-icon.fc00d271e64b104e1b7cbe9e0d4d3cc0.svg";
export { ForwardRef as ReactComponent };